import { RefObject, useEffect, useState } from 'react';
import Slider from 'react-slick';

const usePreventHorizontalScroll = (slider: RefObject<Slider>): void => {
  const [initialTouchPosition, setInitialTouchPosition] = useState<
    number | null
  >(null);

  useEffect(() => {
    const sliderElement = slider.current?.innerSlider?.list;

    const handleTouchStart = (e: TouchEvent): void =>
      setInitialTouchPosition(e.touches[0].clientX);

    const handleTouchMove = (e: TouchEvent): void => {
      if (initialTouchPosition === null) return;

      const threshold = 10;
      const touchMovePosition = e.touches[0].clientX;
      const horizontalSwipeDetected =
        Math.abs(initialTouchPosition - touchMovePosition) > threshold;

      if (horizontalSwipeDetected) e.preventDefault();
    };

    if (sliderElement) {
      sliderElement.addEventListener('touchstart', handleTouchStart);
      sliderElement.addEventListener('touchmove', handleTouchMove, {
        passive: false,
      });
    }

    return () => {
      if (sliderElement) {
        sliderElement.removeEventListener('touchstart', handleTouchStart);
        sliderElement.removeEventListener('touchmove', handleTouchMove);
      }
    };
  }, [initialTouchPosition, slider]);
};

export default usePreventHorizontalScroll;
